import {
  excludeNode,
  getChapterRootFromXml,
  getRelatedLinks,
  isMapRef,
  isTopicRef,
  menuItemTitle,
  parentTitle,
  processChildren,
} from "./menuGeneration";

// This function is used on webModernisation web page
// to generate TOC and guideline navigation
export default function generateMenuFromXml(xmlString) {
  const chapter = getChapterRootFromXml(xmlString);
  const title = parentTitle(chapter);
  const chapterData = getMenuItems(chapter);
  const filteredChapterData = filterMenuItems(chapterData);
  const relatedLinks = getRelatedLinks(xmlString);
  return {
    title: title,
    menuItems: filteredChapterData,
    relatedLinks: relatedLinks,
  };
}

// This function returns full list of menu items
// also indicate if the item is a root chapter or contains submenus
// It can replace the similar function in menuGenerator.jsx
export function getMenuItems(chapterDetails) {
  const result = Array.from(chapterDetails?.childNodes || []).flatMap(
    (item) => {
      if (
        item.getAttribute &&
        (item.getAttribute("mpspath") || item.getAttribute("href"))
      ) {
        const filteredNode = excludeNode(item);
        if (isTopicRef(filteredNode)) return processRootTopicRef(item, true);
        if (isMapRef(filteredNode)) return processTopicRoot(item);
      }
      return [];
    },
  );
  return result;
}

function filterMenuItems(items) {
  if (!items || !Array.isArray(items)) return [];

  const filteredData = items.map((item) => {
    const filteredItem = { ...item };

    if (item.chapter === true) {
      filteredItem.children = [];
      return filteredItem;
    }

    if (item.umbrella === true) {
      if (item.children && item.children.length > 0) {
        filteredItem.children = item.children.map((child) => {
          const filteredChild = { ...child };

          if (child.chapter === true) {
            filteredChild.children = [];
          } else {
            console.warn(`Warning: Child "${child.title}" in umbrella "${item.title}" does not have chapter=true`);
          }
          return filteredChild;
        });
      }
      return filteredItem;
    }
    return filteredItem;
  });
  return filteredData;
}

const processRootTopicRef = (topicRef, hasSubmenu = false) => {
  return {
    id: encodeURIComponent(topicRef.getAttribute("href")),
    title: menuItemTitle(topicRef),
    msPath: topicRef.getAttribute("mpspath"),
    type: "topicref",
    level: topicRef.getAttribute("level"),
    className: topicRef.getAttribute("class"),
    umbrella: hasSubmenu,
    children: processRelatedTopics(Array.from(topicRef.childNodes)),
  };
};

const processRelatedTopics = (children) => {
  return children.flatMap((child) => {
    const filteredNode = excludeNode(child);
    if (isMapRef(filteredNode)) return processTopicRoot(child);
    return [];
  });
};

export function processTopicRoot(item) {
  if (!item) return [];

  return Array.from(item.childNodes).flatMap((child) => {
    if (!child.querySelector) return [];

    const mapElement = child.querySelector(":scope > map");
    const topicrefElement = child.querySelector(":scope > topicref");
    const chapterElement = child.querySelector(":scope > chapter");

    if (mapElement) return processTopicRoot(mapElement);
    if (topicrefElement) return processTopicRef(topicrefElement, true);
    if (chapterElement) return processChapter(chapterElement, true);

    return [];
  });
}

function processChapter(chapter, chapterRoot) {
  return {
    title: menuItemTitle(chapter),
    href: chapter.getAttribute("href"),
    msPath: chapter.getAttribute("mpspath"),
    level: chapter.getAttribute("level"),
    type: "chapter",
    className: chapter.getAttribute("class"),
    chapter: chapterRoot,
    children: processChildren(Array.from(chapter.childNodes).slice(1)),
  };
}

function processTopicRef(topicRef, chapterRoot = false) {
  return {
    id: encodeURIComponent(topicRef.getAttribute("href")),
    title: menuItemTitle(topicRef),
    msPath: topicRef.getAttribute("mpspath"),
    type: "topicref",
    level: topicRef.getAttribute("level"),
    className: topicRef.getAttribute("class"),
    chapter: chapterRoot,
    children: processChildren(Array.from(topicRef.childNodes)),
  };
}
